export default __webpack_public_path__ + "static/media/abtus.a9bdd94e.jpg";